'use strict'
const {
    migrateStylableComponentsByCompType
} = require('../helpers/stylableMigration/migrateStylableComponentsByCompType')

const PRO_GALLERY_COMPTYPE = 'wixui.ProGallery'
const PRO_GALLERY_NON_STYLABLE_SKIN = 'wixui.skins.ProGallery'

const CSS_PROP_TO_VAR_NAME = {
    fill: 'color',
    'background-color': 'background'
}

const CSS_TEXT_PROP_TO_VAR_NAME = {
    'background-color': 'text-highlight',
    'text-decoration-line': 'text-decoration',
    'text-direction': 'direction'
}

const migratePage = (structure, data, uniqueIdGenerator, clientSpecMap, magicObject) => {
    migrateStylableComponentsByCompType({
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        newSkin: PRO_GALLERY_NON_STYLABLE_SKIN,
        compType: PRO_GALLERY_COMPTYPE,
        useCssColor: true,
        magicObject,
        selectorsMappings: {
            '.root': {
                name: 'root',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::gallery-arrows': {
                name: 'navigation-arrows',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::gallery-arrows::gallery-arrows-icon': {
                name: 'navigation-arrows-icon',
                root: 'navigation-arrows',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::gallery-arrows:hover': {
                name: 'navigation-arrows-hover',
                root: 'navigation-arrows',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::item': {
                name: 'item',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::item:hover': {
                name: 'item-hover',
                root: 'item',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::item::overlay': {
                name: 'overlay',
                root: 'item',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::item:hover::overlay': {
                name: 'overlay-hover',
                root: 'overlay',
                properties: CSS_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::item-external-info-description': {
                name: 'external-description',
                properties: CSS_TEXT_PROP_TO_VAR_NAME,
                removePrefix: true
            },
            '.root::item-hover-info-description': {
                name: 'external-description-hover',
                root: 'external-description',
                properties: CSS_TEXT_PROP_TO_VAR_NAME
            },
            '.root::item-external-info-title': {
                name: 'external-title',
                properties: CSS_TEXT_PROP_TO_VAR_NAME
            },
            '.root::item-hover-info-title': {
                name: 'external-title-hover',
                root: 'external-title',
                properties: CSS_TEXT_PROP_TO_VAR_NAME
            },
            '.root::loadmore': {
                name: 'load-more-button',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::pro-gallery-container': {
                name: 'pro-gallery-container',
                properties: CSS_PROP_TO_VAR_NAME
            }
        }
    })
}

// DRAFT MIGRATION - this migration is not complete missing bug fixes & tests
module.exports = {
    name: 'ProGalleryStylesFixer',
    version: 0,
    experimentalVersions: [
        {experiment: 'dm_migrateProGalleryToNonStylable', version: 1},
        {experiment: 'dm_migrateBlocksWidgetsToNonStylable', version: 2}
    ],
    exec(pageJson, pageIdsArray, magicObject) {
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils

        if (!magicObject.isExperimentOpen('dm_migrateProGalleryToNonStylable')) {
            return
        }

        const {data, structure} = pageJson
        migratePage(structure, data, uniqueIdGenerator, clientSpecMap, magicObject)
    },
    fixerRequiresReruns: true
}
